import React from 'react'

export default props => {
  if (typeof window === 'undefined') {
    return null
  }

  const { typeMap } = props

  const previewData = window.__PRISMIC_PREVIEW_DATA__

  if (!previewData) {
    return <Error msg='Preview data not found :(' />
  }

  const type = getType(previewData)
  // seems the data is now taken from the

  const Cmp = typeMap[type]

  if (!Cmp) {
    return (
      <Error
        msg={`
        Preview for type <b>${type}</b> is not currently supported or
        available
      `}
      />
    )
  }

  return <Cmp {...props} />
}

const getType = previewData => {
  if (previewData.type) {
    return previewData.type
  }

  console.log(previewData)

  // get the first thing we see, i guess
  const [data] = Object.values(previewData)

  return data.type
}

const Error = ({ msg }) => (
  <div
    style={{
      fontSize: '26px',
      maxWidth: '500px',
      width: '100%',
      margin: '10px auto',
      padding: '40px',
      background: '#f8f8f8'
    }}
    dangerouslySetInnerHTML={{
      __html: msg
    }}
  />
)
